"use client";

import { Toaster } from "sonner";
import { useTheme } from "next-themes";

export function ThemedToaster() {
  const { resolvedTheme } = useTheme();

  return (
    <Toaster
      theme={resolvedTheme === "dark" ? "dark" : "light"}
      richColors
      position="bottom-center"
      style={{ zIndex: 2147483647 }}
      toastOptions={{ duration: 4000 }}
    />
  );
}
